/*-------------------
  Search New Modal
--------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const opener = document.querySelector('.search_modal_opener');
  const modal = document.querySelector('.search_modal');
  const overlay = document.querySelector('.search_modal_overlay');

  opener?.addEventListener('click', () => {
    modal?.classList.toggle('active');
  });

  modal?.addEventListener('click', (e) => {
    if (e.target.closest('.icon_close')) {
      modal.classList.remove('active');
    }
  });

  overlay?.addEventListener('click', () => {
    modal?.classList.remove('active');
  });
});

// Mega Menu
$(document).ready(function () {
  $(".menu_icon").click(function(){
    $(".menu_list").addClass("active");
  });
  $(".js-close-menu").click(function(){
    $(".menu_list, .mobile_menu_drawwer").removeClass("active");
  });

  if ($(window).width() < 1200) {
    $('body').on('click', '.parrent_menu', function (e) {
      e.preventDefault();
      $(this).next('.mobile_menu_drawwer').addClass('active');
    });
  }

  document.querySelectorAll('.back_menu').forEach(button => {
    button.addEventListener('click', (e) => {
      const drawer = button.closest('.mobile_menu_drawwer');
      if (drawer) {
        drawer.classList.remove('active');
      }
    });
  });
  
  /*-------------------
    Fancy box
  --------------------- */
    
  Fancybox.bind("[data-fancybox]", {
      Thumbs: {
        autoStart: true,
        hideOnClose: false
      },
      contentClick: "iterateZoom",
      Images: {
        Panzoom: {
          maxScale: 2,
        },
      },
      Toolbar: {
        display: {
          left: [],
          middle: [],
          right: ["close"]
        },
      },
  });
  
  /*-------------------
    Slider Height
  --------------------- */
  function setEqualHeightForAllSliders() {
    $('.tns-slider').each(function() {
      var $slider = $(this);
      var $slides = $slider.find('.tns-item');
      $slides.css('height', 'auto');
      var maxHeight = 0;
      $slides.each(function() {
        var slideHeight = $(this).outerHeight();
        if (slideHeight > maxHeight) {
          maxHeight = slideHeight;
        }
      });
        $slides.css('height', maxHeight + 'px');
    });
  }
  setEqualHeightForAllSliders();
  $(window).on('resize', setEqualHeightForAllSliders);
  
});


/*-------------------
  Quantity change
--------------------- */
$('body').on('click', '.qtyBtn', function () {
    const $button = $(this);
    const $input = $button.siblings('input');
    const oldValue = parseFloat($input.val()) || 1;
    let newVal = oldValue;

    if ($button.hasClass('plus')) {
        newVal = oldValue + 1;
    } else if ($button.hasClass('minus')) {
        newVal = Math.max(1, oldValue - 1);
    }

    $input.val(newVal).trigger('change');

    const $atcQuantity = $('#atc_quantity');
    if ($atcQuantity.length) {
        $atcQuantity.val(newVal);
    }
});


$('body').on('input change', '#atc_quantity', function () {
  const newVal = parseFloat($(this).val()) || 1;

  // Update all quantity inputs related to qtyBtn
  $('.qtyBtn').each(function () {
      const $input = $(this).siblings('input');
      if ($input.length) {
          $input.val(newVal).trigger('change');
      }
  });
});


function initializeSwipers() {
  if (
    document.querySelectorAll(".thumb_slider .swiper-slide").length > 0 &&
    document.querySelectorAll(".product_slider .swiper-slide").length > 0
  ) {
    window.thumbSwiper = new Swiper(".thumb_slider", {
      direction: "horizontal",
      mousewheel: true,
      spaceBetween: 4,
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        576: {
          direction: "vertical",
        },
      },
    });

    window.productSwiper = new Swiper(".product_slider", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: window.thumbSwiper,
      },
    });
  }
}

 initializeSwipers();

const replaceContent = (selectors, sectionId, html) => {
  $.each(selectors, (index, selector) => {
    const targetSelector = `[data-${selector}-${sectionId}]`;
    $(targetSelector).html($(html).find(targetSelector).html());
  });
  const $atcQuantity = $('#atc_quantity');
  const quantity = Number($("#product_quantity")?.val());
    if ($atcQuantity.length && quantity) {
        $atcQuantity.val(quantity);
    }
}


const renderProductInfo = (requestUrl, productUrl, sectionId, changeUrl) => {
  fetch(requestUrl)
  .then((response) => response.text())
  .then((responseText) => {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const variant = JSON.parse($(html).find('.product-variant-container [data-selected-variant]').text());
    
    if(changeUrl) window.history.replaceState({}, '', `${productUrl}${variant ? `?variant=${variant.id}` : ''}`);
    replaceContent(["price", "product-form", "qty-cart", "variant-select", "atc-sticky"], sectionId, html);

    if (variant.featured_media) {
      let f_id = variant.featured_media.id;
      let imageEle = document.querySelector('img[data-img="' + f_id + '"]');
    
      let swiperEl = document.querySelector(".product_slider");
      let swiper = swiperEl && swiperEl.swiper;
    
      let slideIndex = Array.from(swiper.slides).findIndex(slide =>
        slide.querySelector('img[data-img="' + f_id + '"]')
      );
    
      if (slideIndex >= 0) {
        swiper.slideTo(slideIndex, 250, false);
      }
    }
  })
  .catch((error) => {
    console.error(error);
  });
}

/*-------------------
  fetch sticky variant
--------------------- */
$("body").on("change", "[data-sticky-select] select", function () {
  const $wrapper = $(this).closest('.sticky_item_wrapper');
  const sectionId = $wrapper.data("section");
  const productUrl = $(this).data("product-url");
  const changeUrl = $wrapper.data("change-url");

  const optionValues = $wrapper.find('select').map(function () {
    return $(this).val();
  }).get().join(',');

  const requestUrl = `${productUrl}?section_id=${sectionId}&option_values=${optionValues}`;
  renderProductInfo(requestUrl, productUrl, sectionId, changeUrl);

});


// Product Variant Change 
$("body").on("change", ".product-variant-container input", function () {
    
  const sectionId = $(this).closest('.product-variant-container').data("section"), productUrl = $(this).data("product-url"), changeUrl = $(this).closest('.product-variant-container').data("change-url");
  const optionValues = $(this).closest(".product-variant-container").find('input:checked').map(function() {
    return $(this).data("option-value-id");
  }).get().join(',');

  const requestUrl = `${productUrl}?section_id=${sectionId}&option_values=${optionValues}`;
  renderProductInfo(requestUrl, productUrl, sectionId, changeUrl);
});


// Product Quick View 
$("body").on("click", ".quick-view-btn", function (e) {
  e.preventDefault();
  const productJson = $(this).data('product');
  const curVar = $(this).data('current-variant');
  console.log("curVar",curVar);
  console.log("productJson",productJson);

  $("#quickViewModal").empty();
  const product_handle = $(this).data("product-handle");
  fetch("/products/" + product_handle + "/?section_id=quick-view")
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      $("#quickViewModal").append($(html).find(".quick-view-modal"));
      initializeSwipers();

        // window._RestockRocket.renderPreorderButton(curVar);
      // Globo?.Preorder?.initPreorder();
    })
});

/*-------------------
  Add to cart
--------------------- */
const addToCart = (formData, _this, _this_text) => {
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: formData,
    processData: false,
    contentType: false,
    dataType: "json",
  })
  .done(function (data) {
    _this.find("span").html("Added");
    if ($("#quickViewModal").hasClass("show")) {
      $("#quickViewModal").find(".close_btn").trigger("click");
    }
    // await window.shopified.onCartUpdated();
    // window.shopified.openCart(); 
    shopified.cartSuccess();
    _this.removeAttr("disabled").find("span").html(_this_text);

  })
  .fail(function (response, status, error) {
    const msg = response.responseJSON?.description || "Something went wrong.";
    const div = $("<div/>", { class: "atc-error" }).html(`<span>${msg}</span>`);
    _this.closest("form").find(".atc-error").remove();
    _this.parent(".main_atc_wrapper").length
      ? _this.parent(".main_atc_wrapper").append(div)
      : _this.before(div);
  
    _this.removeAttr("disabled").find("span").html(_this_text);
  
    div.show().delay(5000).fadeOut(500, function () {
      $(this).remove();
    });
  });
};

$("body").on("click", "[data-add-to-cart]", function (e) {
  e.preventDefault();
  
  var _this = $(this);
  var _this_text = _this.find("span").html();
  var form = _this.closest("form");
  _this.attr("disabled", "disabled").find("span").html("Adding to cart...");

  const formData = new FormData();
  const mainVariantId = form.find("input[name=id]").val();
  const quantityInput = $("#product_quantity");
  const quantity = quantityInput.length ? Number(quantityInput.val()): 1;
  // const quantity = $("#product_quantity").length ? Number($("#product_quantity").val()) : 1;
  const preOrderSellingPlan = form.find(".gPreorderSellingPlanOption:checked");

  formData.append("items[0][id]", mainVariantId);
  formData.append("items[0][quantity]", quantity);

  if (preOrderSellingPlan.length > 0) {
    const sellingPlanId = preOrderSellingPlan.val();
    formData.append("items[0][selling_plan]", sellingPlanId);
  }

  // Append upsell products
   if ($("body").attr("id") === "product") {
    let index = 1;
  
    $(".upsells_block input:checked").each(function () {
      const $label = $(this).closest("label");
      const $select = $label.find("[data-upsell-select]");
      let upsellId = null;
  
      if ($select.length && $select.val()) {
        // Use selected variant from <select>
        upsellId = $select.val();
      } else {
        // Use default variant from data attribute on checkbox
        upsellId = $(this).data("upsell-id");
      }
  
      if (upsellId) {
        formData.append(`items[${index}][id]`, upsellId);
        formData.append(`items[${index}][quantity]`, quantity);
        index++;
      }
    });
  }
  
  addToCart(formData, _this, _this_text);
});

/*-------------------
  cart-recommendations
--------------------- */

const cartRecommendations = (element) => {
    if ($(element).length > 0) {
      var productRecommendationsSection = $(element);
      var url = productRecommendationsSection.data("url");
      $.ajax({
        url: url,
        dataType: "html",
        success: function (data) {
        var htmlData = $(data);
        var recommendations = htmlData.find(element);
      
        if (recommendations.length && recommendations.html().trim().length) {
          productRecommendationsSection.html(recommendations.html());
        }
      },
      error: function (error) {
        console.log("error", error);
      },
    });
  } 
}
cartRecommendations(".cart-recommendations");


/*-------------------
  Sticky - Item
--------------------- */
window.addEventListener('scroll', function () {
  if ($("body").attr("id") === "product") {
    var secondSection = document.querySelector('.product_details .eb-payment-icons');
    var footer = document.querySelector('.sticky_item');
    var secondBottom = secondSection.getBoundingClientRect().bottom;
    if (secondBottom <= 0) {
      footer.classList.add('active');
    } else {
      footer.classList.remove('active');
    }
  }
});

var menuHeight = $('.menu_wrapper').innerHeight();
var ctaHeight = $('.cta-wrapper').innerHeight();``
var announcementHeight = $('#announcement-bar').innerHeight();``
var header = $('#mobile-header').innerHeight();``
function heightVar() {
  $("body").css("--menuHeight", `${menuHeight}px`);
  $("body").css("--ctaHeight", `${ctaHeight}px`);
  $("body").css("--announcementHeight", `${announcementHeight}px`);
  $("body").css("--header", `${header}px`);
}
heightVar();

// 
// window.addEventListener("scroll", function () {
//     const header = document.querySelector(".top-header");
//     const announcement = document.querySelector(".tpro-wrapper");
//     if (window.scrollY > 30) {
//         header.classList.add("sticky");
//         announcement.style.display = "none";
//     } else {
//         header.classList.remove("sticky");
//         announcement.style.display = "block";
//     }
// });